import { createSlice } from "@reduxjs/toolkit";

import { getUser, cancelAutoRenew, changeEarningType, getNotifications, deleteNotifications } from "./actions";

const initialState = {
    user: {},
    plan: null,
    notifications: []
};

export const userSlice = createSlice({
    name: "User",
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
        },

        updateEmail: (state, action) => {
            state.user.email = action.payload;
        },
    },

    extraReducers: {
        [getUser.fulfilled]: (state, action) => {
            state.user = action.payload.user;
            state.plan = action.payload.products;
        },

        [cancelAutoRenew.fulfilled]: (state, action) => {
            let payload = action.payload;
            if (payload) {
                state.plan.auto_renew = "inactive";
            }
        },

        [changeEarningType.fulfilled]: (state, action) => {
            let payload = action.payload;

            if (payload) {
                state.user.referral_type = payload;
            }
        },

        [getNotifications.fulfilled]: (state, action) => {
            let payload = action.payload;

            if (payload) {
                state.notifications = payload;
            }
        },

        [deleteNotifications.fulfilled]: (state, action) => {
            let payload = action.payload;

            if (payload) {
                state.notifications = [];
            }
        },
    },
});

// Action creators are generated for each case reducer function
export const { setUser, updateEmail } = userSlice.actions;

export default userSlice.reducer;